import { gql } from 'graphql-request';

export const key = 'fieldNotes';

export const FIELD_NOTE_FRAGMENT_WITHOUT_ATTACHMENTS_DOCS = gql`
  fragment FieldNoteFieldsWithoutAttachments on FieldNote {
    createdOnDeviceAt
    id
    activity {
      author {
        alias
        id
        isActive
        user {
          id
          familyName
          givenName
        }
      }
      chatChannelKey
      comments {
        chatMessageKey
        id
      }
      eventTimestamp
      id
      media {
        count
        items {
          mobile {
            id
            name
            link {
              url
              createdAt
            }
          }
        }
        nextToken
      }
      message
      operationType
      project {
        id
        number
        name
      }
      source {
        fieldNote {
          id
          createdAt
          updatedAt
          project {
            id
          }
        }
      }
      type
    }
    listOfKeywords {
      id
      name
    }
    locationTags {
      id
      name
    }
    note
    projectId
    project {
      address {
        city
        country
        county
        state
        street1
        street2
        zipCode
      }
      company {
        name
        logo {
          link
        }
        fax
        phone
        address {
          city
          county
          state
          street1
          street2
          zipCode
        }
      }
      id
      name
      number
    }
    createdOnDeviceAt
    keywords
    address {
      street1
      street2
      city
      state
      zipCode
      county
    }
    emails {
      author {
        name
        userId
      }
      bcc {
        email
        name
      }
      boxType
      cc {
        email
        name
      }
      dateReceived
      dateSent
      documents {
        id
        name
      }
      emailLink
      from {
        email
        name
      }
      id
      html
      hasBeenRead
      isUrgent
      lastEditedBy {
        name
        userId
      }
      linkedDocument {
        documentId
        documentName
        documentType
      }
      subject
      text
      to {
        email
        name
      }
    }
    phase
    system
    createdByUsername
    createdByUserId
    updatedAt
    createdAt
    lastUpdatedByUserId
    lastUpdatedByUsername
    _version
    _deleted
    _lastChangedAt
  }
`;

export const getFieldNote = gql`
  query getFieldNote($id: ID!) {
    getFieldNote(id: $id) {
      ...FieldNoteFieldsWithoutAttachments
    }
  }
  ${FIELD_NOTE_FRAGMENT_WITHOUT_ATTACHMENTS_DOCS}
`;

export const listFieldNoteAuthorsSearchFacets = gql`
  query listFieldNoteAuthorsSearchFacets($input: ListFieldNoteAuthorsSearchFacetsInput!) {
    listFieldNoteAuthorsSearchFacets(input: $input) {
      items {
        count
        key
      }
      pagination {
        hits
        currentPage
        pages
        pageSize
      }
    }
  }
`;

export const listFieldNoteKeywordsSearchFacets = gql`
  query listFieldNoteKeywordsSearchFacets($input: ListFieldNoteKeywordsSearchFacetsInput!) {
    listFieldNoteKeywordsSearchFacets(input: $input) {
      items {
        count
        key
      }
      pagination {
        hits
        currentPage
        pages
        pageSize
      }
    }
  }
`;

export const listFieldNoteSearchFacets = gql`
  query listFieldNoteSearchFacets($input: ListFieldNoteSearchFacetsInput!) {
    listFieldNoteSearchFacets(input: $input) {
      authors {
        items {
          count
          key
        }
        pagination {
          hits
          currentPage
          pages
          pageSize
        }
      }
      keywords {
        items {
          count
          key
        }
        pagination {
          hits
          currentPage
          pages
          pageSize
        }
      }
    }
  }
`;

export const searchContacts = gql`
  query searchContacts(
    $direction: ModelSortDirection
    $filter: ContactSearchFilterInput
    $limit: Int
    $page: Int
    $sortBy: ContactSearchSortByColumn
    $term: String
  ) {
    searchContacts(
      limit: $limit
      page: $page
      sortBy: $sortBy
      term: $term
      filter: $filter
      direction: $direction
    ) {
      items {
        document {
          apVendor
          businessName
          businessType
          email
          id
          jobTitle
          name
          notes
          status
        }
        highlight {
          businessName
          businessType
          jobTitle
          name
          notes
        }
      }
      pagination {
        currentPage
        hits
        pageSize
        pages
      }
    }
  }
`;
